import { render, staticRenderFns } from "./NewGrupo.vue?vue&type=template&id=e5b21fc4"
import script from "./NewGrupo.vue?vue&type=script&lang=js"
export * from "./NewGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports